import { RestClientWrapper } from '@/core/api/restClientWrapper';
import { createApi } from '@reduxjs/toolkit/query/react';
import { UploadedFile } from '@/core/types';

const getFormDataForFile = (file: Blob | File): FormData => {
  const formData = new FormData();
  formData.set('multipart', file);
  return formData;
};

export const MediaService = createApi({
  reducerPath: 'media',
  baseQuery: RestClientWrapper,
  endpoints: (builder) => ({
    requestAssetCreate: builder.mutation<UploadedFile, Blob>({
      query: (file) => {
        const data = getFormDataForFile(file);

        return {
          url: '/front/files?public=false',
          requestParams: {
            method: 'post',
            data,
          },
        };
      },
    }),
  }),
});

export const { useRequestAssetCreateMutation } = MediaService;
